import { createFileRoute } from "@tanstack/react-router"
import { TenantsPage } from "@/admin"

export const Route = createFileRoute("/(user)/admin/tenants")({
  validateSearch: (search): { tenantId?: string } => ({
    tenantId: typeof search.tenantId === "string" ? search.tenantId : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { tenantId } = Route.useSearch()

  return <TenantsPage tenantId={tenantId} />
}
